import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { Field, inp } from "@/components/admin/AdminUi";

export function WoSettingsDialog({ open, cfg, onClose, onSaved }) {
  const [f, setF] = useState(null);
  useEffect(() => { if (open && cfg) setF({ ...cfg, typesText: cfg.types.join("\n") }); }, [open, cfg]);
  if (!f) return null;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async () => {
    try {
      const { data } = await api.put("/admin/work-orders/settings", { types: f.typesText.split("\n"), shop_hours: f.shop_hours, wa_message: f.wa_message, email_subject: f.email_subject, email_message: f.email_message });
      toast.success("Impostazioni salvate"); onSaved(data);
    } catch (e) { toast.error(errMsg(e)); }
  };
  const ta = inp.replace("h-10", "min-h-[80px] py-2");
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl max-h-[92vh] overflow-y-auto" data-testid="wo-settings-dialog">
        <DialogHeader><DialogTitle className="text-xl font-extrabold uppercase">Impostazioni ordini in lavorazione</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <Field label="Tipi di prodotto (uno per riga)"><textarea data-testid="wo-set-types" className={ta} value={f.typesText} onChange={set("typesText")} /></Field>
          <Field label="Orari negozio ({orari})"><input data-testid="wo-set-hours" className={inp} value={f.shop_hours} onChange={set("shop_hours")} /></Field>
          <Field label="Messaggio WhatsApp"><textarea data-testid="wo-set-wa" className={ta} value={f.wa_message} onChange={set("wa_message")} /></Field>
          <Field label="Oggetto email"><input data-testid="wo-set-subject" className={inp} value={f.email_subject} onChange={set("email_subject")} /></Field>
          <Field label="Testo email"><textarea data-testid="wo-set-email" className={ta} value={f.email_message} onChange={set("email_message")} /></Field>
          <p className="text-xs text-slate-500">Segnaposto: {"{nome}"} {"{prodotto}"} {"{saldo}"} {"{orari}"} {"{numero}"}</p>
          <button data-testid="wo-set-save" onClick={save} className="press w-full h-11 rounded-md bg-brand-yellow text-brand-navy font-bold">Salva</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
